export const DATA_MANAGER_SECTION_KEYS = [
  "orders",
  "trucks",
  "compartments",
  "client_correspondences",
  "employees",
  "products",
  "product_catalog",
  "time_window_tolerances",
  "history",
  "planning",
];

const DATA_MANAGER_BASE_SECTIONS_BY_TAB = {
  // Le produit associé d'une remorque se choisit dans le catalogue Produits.
  compartments: ["trucks", "product_catalog"],
  correspondences: ["client_correspondences"],
  employees: ["employees"],
  products: ["products", "product_catalog"],
  product_catalog: ["product_catalog"],
  orders: ["orders", "product_catalog", "products"],
  vehicles: ["trucks", "employees"],
};

export function resolveDataManagerRequestedSections(
  activeTab,
  { includeHistory = false, includePlanning = false } = {},
) {
  const baseSections = DATA_MANAGER_BASE_SECTIONS_BY_TAB[activeTab] || DATA_MANAGER_BASE_SECTIONS_BY_TAB.orders;
  const requestedSections = [...baseSections];

  if (includePlanning && !requestedSections.includes("planning")) {
    requestedSections.push("planning");
  }

  if (includeHistory && !requestedSections.includes("history")) {
    requestedSections.push("history");
  }

  return requestedSections;
}

export function resolveDataManagerLazySections(lazySections = [], requiredSections = []) {
  const requiredSectionSet = new Set(Array.isArray(requiredSections) ? requiredSections : []);
  const lazySectionSet = new Set(Array.isArray(lazySections) ? lazySections : []);

  return DATA_MANAGER_SECTION_KEYS.filter(
    (sectionKey) => lazySectionSet.has(sectionKey) && !requiredSectionSet.has(sectionKey),
  );
}
